import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WildCardComponent } from "./wild-card.component";


@NgModule({
  declarations: [ WildCardComponent ],
  imports: [ CommonModule ],
  exports: [ WildCardComponent ]
})
export class NewellWildCardModule { }
